import { render, staticRenderFns } from "./AnalisiRischiThList.vue?vue&type=template&id=71191bdd"
import script from "./AnalisiRischiThList.vue?vue&type=script&lang=js"
export * from "./AnalisiRischiThList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports